export const tasksData = [
    {
        task: 'Prepare a presentation',
        date: '06/05/2023',
        projectId: 'p1',
        taskId: 't1',
        archived: false,
        today: false,
        deleted: false,
    },
    {
        task: 'Submit a report',
        date: '06/05/2023',
        projectId: 'p1',
        taskId: 't2',
        today: false,
        deleted: false,
        archived: false,
    },
    {
        task: 'Write a project report',
        date: '05/05/2023',
        projectId: 'p1',
        taskId: 't3',
        archived: false,
        today: true,
        deleted: false,
    },
    {
        task: 'Launch website',
        date: '08/05/2023',
        projectId: 'p2',
        taskId: 't4',
        today: false,
        deleted: false,
        archived: true,
    },
    {
        task: 'Redesign homepage',
        date: '08/05/2023',
        projectId: 'p2',
        taskId: 't5',
        today: false,
        deleted: true,
        archived: false,
    },
    {
        task: 'Make a notes web app',
        date: '08/05/2023',
        projectId: 'p2',
        taskId: 't6',
        today: false,
        deleted: false,
        archived: true,
    },
    {
        task: 'Create a to-do lists web app',
        date: '08/05/2023',
        projectId: 'p2',
        taskId: 't7',
        today: false,
        deleted: false,
        archived: true,
    },
]